import React from 'react';
import { Link } from 'react-router-dom';

import { CiRead } from 'react-icons/ci';
import { type ColumnDef } from '@/components/organism/Table';
import AppButton from '@/components/atoms/AppButton';
import Tooltip from '@/components/atoms/Tooltip';
import { copyToClipboard } from '@/utils/copyToClipboard';
import { USER_CONSTANT_PROPS } from '@/constant/users/user.constant';
import { getDateTime } from '@/utils/dateTime';
import { getRoleNames } from '@/services/role';
import { IUser } from '@/services/user/user.type';

export function buildColumns(
  isCopy: boolean,
  onCopyClick: () => void,
  rolesInfo: any[],
): ColumnDef<IUser>[] {
  return [
    {
      accessor: 'firstName',
      header: USER_CONSTANT_PROPS.COLUMNS.FIRST_NAME,
      sorting: true,
      render: (item, idx) => (
        <Tooltip id="first_name_tooltip" showToolTips={isCopy} label="Copy">
          <Tooltip content={item?.firstName} placement="right">
            <span
              className="cursor-pointer hover:text-primary transition-colors overflow-hidden whitespace-nowrap w-[100px] inline-block text-ellipsis"
              onClick={() => {
                copyToClipboard(item?.firstName ?? '');
                onCopyClick();
              }}
            >
              {item?.firstName}
            </span>
          </Tooltip>
        </Tooltip>
      ),
    },
    {
      accessor: 'lastName',
      header: USER_CONSTANT_PROPS.COLUMNS.LAST_NAME,
      sorting: true,
    },
    {
      accessor: 'email',
      header: USER_CONSTANT_PROPS.COLUMNS.EMAIL,
      sorting: true,
      render: (item, idx) => (
        <Tooltip id="email_id_tooltip" showToolTips={isCopy} label="Copy">
          <Tooltip content={item?.email} placement="right">
            <span
              className="cursor-pointer hover:text-primary transition-colors overflow-hidden whitespace-nowrap w-[180px] inline-block text-ellipsis"
              onClick={() => {
                copyToClipboard(item?.email);
                onCopyClick();
              }}
            >
              {item?.email}
            </span>
          </Tooltip>
        </Tooltip>
      ),
    },
    {
      accessor: 'roleIds',
      header: USER_CONSTANT_PROPS.COLUMNS.ROLE_NAME,
      render: (item, idx) => (
        <span>{getRoleNames(item?.roleIds, rolesInfo)?.roleNameString}</span>
      ),
    },
    {
      accessor: 'updatedOn',
      header: USER_CONSTANT_PROPS.COLUMNS.UPDATED_ON,
      sorting: true,
      render: (item, idx) => <span>{getDateTime(item?.updatedOn)}</span>,
    },
    {
      accessor: 'createdOn',
      header: USER_CONSTANT_PROPS.COLUMNS.CREATED_ON,
      sorting: true,
      render: (item, idx) => <span>{getDateTime(item?.createdOn)}</span>,
    },
    {
      accessor: 'action',
      header: USER_CONSTANT_PROPS.COLUMNS.ACTION,
      render: (item, idx) => (
        <Link to={`/users/${item.userId}`} state={{ ...item, rolesInfo }}>
          <AppButton
            variant="info"
            shape="circle"
            size="xs"
            hoverBg={false}
            icon={<CiRead className="w-4 h-4" />}
          />
        </Link>
      ),
    },
  ];
}
